import { unwrapShareUrl } from './share-url.js';

// An attached packshot has no name/ASIN to look up, so it travels in
// reference_images_urls, and the backend makes the first of those the BASE image
// Gemini edits ("preserve this image as the primary composition"). That is right
// for types that bake the product in, and wrong for the ones that must not show
// it (Feature-Benefits, Reason To Believe, Ingredients, How To): Gemini paints
// the infographic over the photo and sometimes leaves half of the product behind.
// Send the packshot in product_images_names instead, as a product reference, the
// role an ASIN's packshot already has. The controller reads only absolute URLs
// there as images (anything else is looked up as a product name), so relative
// links get the page origin. Pure so it can be verified with `node --test`.
// (POR-14765)
export function attachedProductAsReference({ productNames, productImageUrls, origin }) {
  if (productNames.length || !productImageUrls.length) {
    return { productNames, productImageUrls };
  }

  const absolute = (url) => (typeof url === 'string' && url.startsWith('/') && origin ? origin + url : url);

  return {
    productNames: productImageUrls.map((url) => absolute(unwrapShareUrl(url))),
    productImageUrls: [],
  };
}
